import AddressValidationModelBase from '../_generated/modelBases/address-validation-model-base';

export default class AddressValidationModel extends AddressValidationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
